export const theme = {
    "Layout": {
        "color": "#F0F0F7FF",
        "headerColor": "#F0F0F7FF",
        "siderColor": "#FFFFFFFF",
        "textColor": "#112650FF",
        "footerColor": "#FFFFFFFF",
        "footerColorInverted": "#9E9ACAFF"
    },
    "Input": {
        "paddingLarge": "0 50px",
        "heightLarge": "55px",
        "countTextColor": "rgb(118, 124, 130)",
        "placeholderColor": "#888F9DFF",
        "textColorDisabled": "rgba(194, 194, 194, 1)",
        "textColor": "#112650FF",
        "border": "none",
        "caretColor": "#112650FF",
        "loadingColor": "#18a058",
        "colorFocus": "rgba(255, 255, 255, 1)",
        "borderFocus": "none",
        "borderHover": "none",
        "boxShadowFocus": "0 0 0 2px rgba(94, 87, 166, 0.2)",
        "paddingMedium": "0 24px",
        "heightMedium": "55px"
    },
    "Divider": {
        "textColor": "#112650FF",
        "color": "#DFDDEDFF"
    },
    "Button": {
        "paddingLarge": "0 18px",
        "borderRadiusLarge": "8px",
        "borderRadiusTiny": "8px",
        "borderRadiusSmall": "8px",
        "borderRadiusMedium": "8px",
        "iconMarginLarge": "12px",
        "heightLarge": "52px",
        "textColor": "#5D57A6FF",
        "color": "#dfddedFF",
        "colorHover": "#5D57A6FF",
        "textColorHover": "#DFDDEDFF",
        "border": "none",
        "borderHover": "none",
        "borderPressed": "none",
        "borderDisabled": "none",
        "fontWeight": "600",
        "fontWeightStrong": "700",
        "textColorFocus": "#5D57A6FF",
        "textColorPressed": "#DFDDEDFF",
        "colorFocus": "#DFDDEDFF",
        "rippleColor": "#5D57A6FF",
        "colorSecondary": "rgba(255, 255, 255, 1)",
        "colorSecondaryHover": "#596885FF",
        "colorSecondaryPressed": "rgba(46, 51, 56, .13)",
        "colorPrimary": "#FFFFFFFF",
        "textColorPrimary": "#596885FF",
        "colorHoverPrimary": "#2B2656FF",
        "borderPrimary": "2px solid #7D8FB5",
        "borderHoverPrimary": "2px solid #7D8FB5",
        "borderPressedPrimary": "2px solid #7D8FB5",
        "borderFocusPrimary": "2px solid #7D8FB5",
        "borderDisabledPrimary": "2px solid #7D8FB5B3",
        "textColorTextPressedPrimary": "#DADADAFF",
        "colorPressedPrimary": "#5D57A6E3",
        "colorFocusPrimary": "#5D57A699",
        "textColorGhostPrimary": "#18a058",
        "rippleColorPrimary": "#5D57A6FF",
        "borderFocus": "1px solid #5D57A6FF",
        "colorDisabledPrimary": "#59688542",
        "textColorDisabledPrimary": "#5D57A6BD",
        "colorDisabled": "#59688542",
        "textColorTextHover": "#36ad6a",
        "textColorGhostHover": "#5D57A6FF"
    },
    "Switch": {
        "buttonColor": "#9E9ACAFF",
        "railColorActive": "#FFFFFFFF",
        "iconColor": "rgba(255, 255, 255, 1)",
        "railColor": "#112650FF",
        "buttonBoxShadow": "0 1px 4px 0 rgba(125, 143, 181, 0.57), inset 0 0 1px 0 rgba(125, 143, 181, 0.57)",
        "buttonHeightMedium": "16px",
        "buttonWidthMedium": "16px",
        "boxShadowFocus": "0 0 0 3px rgba(125, 143, 181, 0.57)"
    },
    "Card": {
        "paddingSmall": "12px",
        "color": "#FFFFFFFF",
        "borderRadius": "10px",
        "borderColor": "rgba(222, 222, 222, 1)",
        "paddingMedium": "16px",
        "paddingHuge": "23px 32px 24px",
        "paddingLarge": "24px 20px 24px"
    },
    "Tag": {
        "colorInfo": "#7D8FB5FF",
        "textColorInfo": "#FFFFFFFF",
        "colorBorderedInfo": "#7D8FB5FF",
        "borderRadius": "3px",
        "textColorSuccess": "#FFFFFFFF",
        "colorSuccess": "#9E9ACAFF",
        "colorBorderedSuccess": "#9E9ACAFF",
        "borderSuccess": "none",
        "textColorCheckable": "rgba(255, 255, 255, 1)"
    },
    "Select": {},
    "TreeSelect": {
        "menuColor": "#fff"
    },
    "Pagination": {
        "itemTextColorHover": "#36ad6a",
        "itemTextColorActive": "#4C52A3FF",
        "itemBorderActive": "1px solid #4C52A3",
        "itemTextColor": "#112650FF",
        "itemColorActive": "#1126500D"
    },
    "Dialog": {
        "iconSize": "20px",
        "iconColor": "#5D57A6FF",
        "closeColorHover": "rgba(0, 0, 0, 0)",
        "closeColorPressed": "rgba(0, 0, 0, 0)",
        "closeIconColor": "rgba(38, 38, 38, 1)",
        "closeIconColorHover": "#5D57A6FF",
        "closeIconColorPressed": "#5D57A6FF"
    }
}

export const darkTheme = null